export const packages = [
  {
    name: "Silver Package",
    includes: [
      "24 inch Hood & Fenders",
      "Door Cups & Mirrors",
      "Front Bumper (No Trim)",
    ],
    dealerPrice: 799.95,
    retailPrice: 1399.95,
  },
  {
    name: "Gold Package",
    includes: [
      "24 inch Hood & Fenders",
      "Door Cups & Mirrors",
      "Front Bumper (No Trim)",
      "Grille (Only Painted Grilles)",
    ],
    dealerPrice: 899.95,
    retailPrice: 1549.95,
  },
  {
    name: "Platinum Package",
    includes: [
      "Full Hood & Fenders",
      "Door Cups & Mirrors",
      "Front Bumper (No Trim)",
    ],
    dealerPrice: 1249.95,
    retailPrice: 2499.95,
  },
];
